export const TAB_VALUES = {
  MALL_INTERLOCK: 'mallInterlock',
  DATA_PROVIDER: 'dataProvider',
};

export const MALL_LINKAGE_STATUS_LIST = [
  { label: '연동실패', value: 'FAIL' },
  { label: '연동불가', value: 'UNAVAILABLE' },
  { label: '연동대기', value: 'WAIT' },
  { label: '연동완료', value: 'FINISH' },
  { label: '연동중지', value: 'STOP' },
];

export const DATA_PROVIDER_LINKAGE_STATUS_LIST = [
  { label: '연동실패', value: 'FAIL' },
  { label: '연동대기', value: 'WAIT' },
  { label: '연동완료', value: 'FINISH' },
  { label: '연동중지', value: 'STOP' },
];

export const LINKAGE_STATUS_NAME = {
  FAIL: '연동실패',
  NOT_LINKED: '미연동',
  UNAVAILABLE: '연동불가',
  WAIT: '연동대기',
  FINISH: '연동완료',
  STOP: '연동중지',
};

export const DATA_INTERLOCK_NOTICE_MESSAGE = (
  <p>
    연동된 판매몰이 없습니다.
    <br />
    <br />
    운영 중인 판매몰을 등록해 주세요.
    <br />
    판매몰이 많을수록 대출 신청에 더 유리해요.
  </p>
);

export const DATA_PROVIDER_NOTICE_MESSAGE = (
  <p>
    연동된 데이터 제공사가 없습니다.
    <br />
    <br />
    운영 중인 데이터 제공사를 등록해 주세요.
    <br />
    데이터 제공사가 많을수록 대출 신청에 더 유리해요.
  </p>
);

/* 25.04.16 기준 노션 문서 현행화 */
export const DATA_LINKAGE_ERR_BTN_CASE = {
  askInquire: [
    'FRT112',
    'FRT113',
    'FRT122',
    'FRT123',
    'FRT131',
    'FRT132',
    'FRT133',
    'FRT141',
    'FRT168',
    'FRT169',
    'FRT997',
    'FRT998',
    'FRT999',
  ],
  captureRequest: ['FRT151', 'FRT155', 'FRT158'],
  editMallAccountInfo: ['FRT111'],
  noButton: [
    'FRT126',
    'FRT127',
    'FRT129',
    'FRT134',
    'FRT157',
    'FRT161',
    'FRT162',
    'FRT163',
    'FRT164',
    'FRT165',
    'FRT167',
    'FRT172',
  ],
  secondAuthRequest: ['FRT121', 'FRT124', 'FRT128', 'FRT171'],
  scrapingRequest: ['FRT114', 'FRT142', 'FRT143'],
  // QR 인증 혹은 일반 2차인증 공용 코드
  secondAuthOrQRAuth: ['FRT125'],
};

// 연동 상태별 수정, 삭제, 대출 가능 여부
export const statusActions = {
  FAIL: { modify: true, delete: true, loan: false },
  WAIT: { modify: false, delete: false, loan: false },
  STOP: { modify: true, delete: true, loan: false },
  FINISH: { modify: true, delete: true, loan: true },
  UNAVAILABLE: { modify: true, delete: true, loan: false },
};

export const updateStatusActions = value => {
  statusActions.WAIT.modify = value;
  statusActions.WAIT.delete = value;
};
